module.exports = __webpack_public_path__ + "img/preview-12.e5913bfa.png";